






import {Component, Prop, Vue} from 'vue-property-decorator';
import type {ILandingPageElementText} from '../../../store';
import type {ILBElementComponent} from '../../../types';


@Component
export default class LBElementSpace extends Vue implements ILBElementComponent {
	@Prop({required: true})
	element!: ILandingPageElementText;

	@Prop({type: Boolean, default: false})
	isEditMode!: boolean;
}
